export const TYPES = {
  FIREBASE_AUTH_STATUS: "auth/FIREBASE_AUTH_STATUS",
  FIREBASE_AUTH_PHONE: "auth/FIREBASE_AUTH_PHONE",
  REGISTER_SUCCESS: "auth/REGISTER_SUCCESS",
  REGISTER_FAILED: "auth/REGISTER_FAILED",
};
